<script>
export default {
  beforeCreate() {
    const { query } = this.$route
    const path = query.path
    this.$router.replace({ name: path })
  },
  mounted() {},
  render: function(h) {
    return h() // avoid warning message
  }
}
</script>


// WEBPACK FOOTER //
// src/components/redirect.vue